<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar title="Avalicação de participação e relatório de atividades na ação pelo bolsista"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-layout align-center justify-center>
                <v-flex xs12 lg8>


                  <br><br>

                  Atendendo à Instrução Normativa No 01/2017-PROEX, ao final do seu período de atuação como
                  bolsista, o aluno deverá proceder à sua “AVALIAÇÃO DE PARTICIPAÇÃO E RELATÓRIO DE ATIVI-
                  DADES” na ação de extensão “NOME DA AÇÃO DE EXTENSAO”, referente ao período de XX/XX/XXXX
                  a XX/XX/XXXX, respondendo o seguinte questionário a seguir.
                  Obs.: Caso a atuação do bolsista seja finalizada antes do prazo previsto inicialmente, ele deverá realizar a
                  avaliação da mesma forma, mesmo que por um mês de atividade.

                  <br><br><br><br>


                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <v-text-field
                        label='Nome da ação de extensão'
                        required
                        :rules="regrasBasicas"
                        max-height="400">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex xs11 sm8>
                      <v-text-field
                        label='Nome do aluno'
                        required
                        :rules="regrasBasicas"
                        max-height="400">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs11 sm3>
                      <v-text-field
                        label='Matrícula'
                        required
                        :rules="regrasBasicas"
                        max-height="20">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex xs11 sm8>
                      <v-text-field
                        label='Nome do orientador'
                        required
                        :rules="regrasBasicas"
                        max-height="400">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs11 sm3>
                      <v-text-field
                        label='Tipo de bolsa'
                        required
                        :rules="regrasBasicas"
                        max-height="20">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex xs11 sm4>
                      <c-date-menu
                        label="Data inicial de atuação"
                        clearable
                        required
                        :rules="regrasBasicas"
                      ></c-date-menu>
                    </v-flex>
                    <v-flex xs11 sm4>
                      <c-date-menu
                        label="Data final de atuação"
                        clearable
                        required
                        :rules="regrasBasicas"
                      ></c-date-menu>
                    </v-flex>
                    <v-flex xs11 sm2>
                      <v-text-field
                        label='Carga horária'
                        type="number"
                        required
                        :rules="chRules"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <br><br><br><br>

                  <c-selecionar-nota
                    label="Desenvolvimento do ponto de vista pessoal e acadêmico"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Interação da formação acadêmica com a prática"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Vivência prática da integração ensino, pesquisa e extensão"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Contribuição com a melhoria da sociedade"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Desenvolvimento de senso de cidadania"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Desenvolvimento da autonomia"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Orientação recebida da coordenação"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <c-selecionar-nota
                    label="Pontuação média obtida (ou avaliação qualitativa geral atribuída)"
                    :rules="regrasBasicas"
                  ></c-selecionar-nota>

                  <v-layout>
                    <label class="black--text" style="margin-bottom: 10px">
                      Relatório de atividades desenvolvidas pelo bolsista na ação (descrição sucinta).
                    </label>
                  </v-layout>

                  <v-layout>
                    <v-textarea
                      :rows="5"
                      multi-line
                      counter="500"
                      :rules="couterRules"
                      required
                      v-model="avaliacao.relatorio"
                      outlined
                    ></v-textarea>
                  </v-layout>

                </v-flex>
              </v-layout>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarBolsa" :disabled="!formularioValido">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import SelecionarNota from '@/components/c-selecionar-nota'
  import bolsas from '@/utils/bolsas'
  import DateMenu from '@/components/c-date-menu'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      formularioValido: false,
      avaliacao: {
        relatorio: ''
      },
      regrasBasicas: [
        (input) => input !== undefined || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      criarBolsa: function () {
        console.log(this.avaliacao.nota)
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      bolsas.getPermissoesUnidades()
      .then(response => {
        this.listaPermissoesUnidades = response.data.slice()
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-selecionar-nota': SelecionarNota,
      'c-date-menu': DateMenu
    }
  }
</script>



// WEBPACK FOOTER //
// avaliacao-bolsista.vue?69e1f603